import React from 'react'
import { Link } from '@paypalcorp/pp-react'

interface Props {
  className?: string
  leftIcon?: React.ReactNode
  children: React.ReactNode
  onClick: Function
}

const TextLinkAsButton = ({
  className,
  leftIcon,
  children,
  onClick
}: Props) => {
  const customClassName = className ? ' ' + className : ''
  return (
    <Link
      className={`text-link-as-button${customClassName}`}
      as="button"
      leftIcon={leftIcon}
      onClick={onClick}
    >
      <span className="text-link-as-button__text">{children}</span>
    </Link>
  )
}

export default TextLinkAsButton
